import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { TenantCommunicationTemplate } from './communication-template.interface';
import { CommunicationTemplateService, TENANT_COMMUNICATION_TEMPLATE_INCLUDES } from './communication-template.service';
const service = new CommunicationTemplateService();

export interface CommunicationTemplateState {
   communicationTemplates: Array<TenantCommunicationTemplate>;
}

const CommunicationTemplateStore: Module<CommunicationTemplateState, StoreState> = {
   namespaced: true,
   state: { communicationTemplates: [] },
   getters: {},
   mutations: {
      SET_COMMUNICATION_TEMPLATES(state, communicationTemplates: Array<TenantCommunicationTemplate>) {
         state.communicationTemplates = communicationTemplates;
      },
   },
   actions: {
      async getCommunicationTemplates(context, query: LocationQuery) {
         const response = await service.getCommunicationTemplates({
            ...query,
            include: TENANT_COMMUNICATION_TEMPLATE_INCLUDES.join(','),
            per_page: '9999',
            page: '1',
         });
         context.commit('SET_COMMUNICATION_TEMPLATES', response.data);
      },
   },
};

export default CommunicationTemplateStore;
